"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.keyframes = void 0;

var _styledComponents = require("styled-components");

/**
 * Module dependencies.
 */

/**
 * `FadeIn` animation.
 */
var fadeIn = (0, _styledComponents.keyframes)(["from{opacity:0;}to{opacity:1;}"]);
/**
 * `Spin` animation keyframes.
 */

var spin = (0, _styledComponents.keyframes)(["from{transform:rotate(0deg);}to{transform:rotate(360deg);}"]);
/**
 * Export `keyframes`.
 */

var keyframes = {
  fadeIn: fadeIn,
  spin: spin
};
exports.keyframes = keyframes;